var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67665 4.82322L4.17665 2.32322C4.12977 2.27634 4.06618 2.25 3.99988 2.25C3.93358 2.25 3.86999 2.27634 3.82311 2.32322L1.32311 4.82322C1.28814 4.85818 1.26433 4.90273 1.25468 4.95122C1.24504 4.99972 1.24999 5.04998 1.26891 5.09567C1.28783 5.14135 1.31987 5.18039 1.36099 5.20786C1.4021 5.23533 1.45043 5.24999 1.49988 5.24999H6.49988C6.54932 5.24999 6.59766 5.23533 6.63877 5.20786C6.67989 5.18039 6.71193 5.14135 6.73085 5.09567C6.74977 5.04998 6.75472 4.99972 6.74508 4.95122C6.73543 4.90273 6.71162 4.85818 6.67665 4.82322V4.82322Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73085 8.90433C6.71193 8.85865 6.67988 8.8196 6.63877 8.79213C6.59766 8.76466 6.54932 8.75 6.49988 8.75H1.49988C1.45043 8.75 1.4021 8.76466 1.36098 8.79213C1.31987 8.8196 1.28783 8.85865 1.26891 8.90433C1.24999 8.95001 1.24504 9.00028 1.25468 9.04878C1.26433 9.09727 1.28814 9.14182 1.32311 9.17678L3.82311 11.6768C3.84632 11.7 3.87388 11.7184 3.90421 11.731C3.93454 11.7435 3.96705 11.75 3.99988 11.75C4.03271 11.75 4.06522 11.7435 4.09555 11.731C4.12588 11.7184 4.15344 11.7 4.17665 11.6768L6.67665 9.17678C6.71162 9.14182 6.73543 9.09727 6.74508 9.04877C6.75472 9.00028 6.74977 8.95001 6.73085 8.90433Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdown);
export default __webpack_public_path__ + "static/media/updown.af12cb80307c3cf53835655335091432.svg";
export { ForwardRef as ReactComponent };